var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFailed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5858L16.2426 6.34315C16.6332 5.95262 17.2663 5.95262 17.6568 6.34315C18.0474 6.73367 18.0474 7.36683 17.6568 7.75736L13.4142 12L17.6568 16.2426C18.0474 16.6332 18.0474 17.2663 17.6568 17.6568C17.2663 18.0474 16.6332 18.0474 16.2426 17.6568L12 13.4142L7.75736 17.6568C7.36683 18.0474 6.73367 18.0474 6.34315 17.6568C5.95262 17.2663 5.95262 16.6332 6.34315 16.2426L10.5858 12L6.34315 7.75736C5.95262 7.36683 5.95262 6.73367 6.34315 6.34315C6.73367 5.95262 7.36683 5.95262 7.75736 6.34315L12 10.5858Z",
    fill: "#ff0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFailed);
export default __webpack_public_path__ + "static/media/DownloadFailed.674a3f9cba4b3bf2913a81065451fbc6.svg";
export { ForwardRef as ReactComponent };